import { Component, OnInit, Output, EventEmitter,Input } from '@angular/core';
import {default as GridColumnsJSON} from 'app/Shared/Constant/Grid Column Names/CMTA_OOC_Details_Column.json';
import { SharedHttpClientService } from 'app/Shared/Services/shared-http-client.service';
import { UrlsService } from 'app/Shared/Services/urls.service';
import { APIURL } from 'app/Shared/Constant/API_Urls';
import { HttpErrorResponse } from '@angular/common/http';
import { OptionOriginCode } from './../option-origin-code.model';
import { UserService } from 'app/Shared/Services/user.service';
import { generateCsv, asBlob } from "export-to-csv";
import { saveAs } from 'file-saver';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { EmitterService } from 'app/Shared/Services/emitter.service';
import { MessageService } from 'primeng/api';
import { DialogModule } from 'primeng/dialog';
import { GridComponent } from 'app/Shared/Modules/non-transactional-grid/grid/grid.component';
import { GridService } from 'app/Shared/Services/grid.service';
import { ToastModule } from 'primeng/toast';
@Component({
    selector: 'app-ooc-cmta-details',
    imports: [DialogModule, GridComponent, ToastModule],
    templateUrl: './ooc-cmta-details.component.html',
    styleUrls: ['./ooc-cmta-details.component.scss']
})
export class OocCmtaDetailsComponent implements OnInit {
  isVisible: boolean = false;
  GridColumns = GridColumnsJSON;
  dataset: any = [];
  totalRecords: number = 0;
  limit: any = { 'Start': '0', 'End': '15' };
  @Input() selectedRow!: OptionOriginCode;
  @Output() closeDialog: EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor(private sharedHttpClientService: SharedHttpClientService,
    private urlsService: UrlsService, 
    private userService: UserService,
    public constantService: ConstantService,
    private emitterService: EmitterService,
    private messageService: MessageService,
    private gridService: GridService
    ) { }

  ngOnInit() {
    this.getData()
  }
  getData() {
    let payload = {
      mpid: this.userService.getActiveMPID(),
      reportDate: this.selectedRow.reportDate,
      customerId: this.selectedRow.customerId,
      startLimit: this.limit.Start.toString(),
      endLimit: this.limit.End.toString()
    }
    this.sharedHttpClientService.post(this.urlsService.setAPIURl(APIURL.OptionOriginCode_GetCMTADetails), payload)
      .subscribe({
        next: (dataset:any) => {
        let data = dataset;
        this.dataset = data.response.dataList ? data.response.dataList: [];
        this.totalRecords = data.response.totalCount;
        this.isVisible = true;
        this.totalRecords = this.gridService.handleNoRecordsPageNumber(this.totalRecords);

      },
        error: (err: HttpErrorResponse) => {  
          this.dataset = [];
          this.totalRecords = 0;
          this.totalRecords = this.gridService.handleNoRecordsPageNumber(this.totalRecords);
        }});
  }
  GridChangeLimitEvent(event: any) {
    this.limit = event;
    this.getData();
  }
  closeDialogbox() {
    this.closeDialog.emit(true);
  }
  exportToCSV(response: any) {
    let payload = {
      mpid: this.userService.getActiveMPID(),
      reportDate: this.selectedRow.reportDate,
      customerId: this.selectedRow.customerId,
      startLimit: response.Start.toString(),
      endLimit: response.End.toString()
    }
    this.sharedHttpClientService.post(this.urlsService.setAPIURl(APIURL.OptionOriginCode_GetCMTADetails), payload)
      .subscribe({
        next: (dataset:any) => {
        let data = dataset;
        let exportData = data.response.dataList;
        if(exportData.length > 0) {
          const options: any = {
            fieldSeparator: ',',
            quoteStrings: '"',
            decimalSeparator: '.',
            showLabels: true,
            showTitle: true,
            title: 'RSMS_CMTA_Details_' + this.userService.getyyyyMMddDateFormate(new Date()),
            useTextFile: false,
            useBom: true,
            useKeysAsHeaders: true,
            // header: ['col 1', 'col 2'] // Won't work with useKeysAsHeaders present!
            filename: this.userService.getActiveMPID() +'_RSMS_CMTA_Details_' + this.userService.getyyyyMMdd_HH_MM_SSDateFormate(new Date()),
          };
          const csvData = this.constantService.getExportData(exportData, response.event.gridColumn);
          const csv = generateCsv(options)(csvData);
          const blob = asBlob(options)(csv);
          saveAs(blob,options.filename);

        } else {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No data found' });
        }
        this.emitterService.exportToCSVData.emit(true);
      },
      error: (err: HttpErrorResponse) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error while Exporting' });
        }});
    
  }
}
